/**
 * @ngdoc directive
 * @name directiveSuccessBoxes
 * @restrict A
 *
 * @description
 * Directive for advanced search.
 */
export default function (config) {
    'ngInject';

    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {
            raceId: '='
        },
        link: (directiveSuccessBoxesCtrl) => {
            directiveSuccessBoxesCtrl.init();
        },
        templateUrl: `${config.get('assetsURL')}views/successBox.html`,
        controller: 'directiveSuccessBoxesCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/successBoxes.js